<script>
import { colors } from '@/config'

import getOptionsString from '@/util/getOptionsString'

export default {

  data () {
    return {
      color: colors.lightBlue
    }
  },

  computed: {

    isOnPlayerNode () {
      return this.$store.getters.cursorNodeId === this.$store.getters.playerNodeId
    },

    geometry () {
      return getOptionsString({
        primitive: 'box',
        width: 0.1,
        height: 0.1,
        depth: 0.1
      })
    },

    material () {
      return getOptionsString({
        side: 'double',
        color: colors.lightBlue,
        transparent: true,
        opacity: this.isOnPlayerNode ? 0.2 : 1
      })
    },

    rotationAnimation () {
      return getOptionsString({
        property: 'object3D.rotation.y',
        from: 0,
        to: 360,
        dur: 4000,
        loop: true,
        easing: 'linear',
        enabled: !this.isOnPlayerNode
      })
    },

    bounceAnimation () {
      return getOptionsString({
        property: 'object3D.position.y',
        from: 0,
        to: -0.2,
        dur: 2000,
        dir: 'alternate',
        loop: true,
        easing: 'easeInQuad',
        enabled: !this.isOnPlayerNode
      })
    }

  }

}
</script>

<template>
  <a-entity
    rotation="90 0 0"
  >
    <a-entity
      :geometry="geometry"
      :material="material"
      :animation="rotationAnimation"
      :animation__pos="bounceAnimation"
      rotation="45 0 45"
    />
  </a-entity>
</template>
